import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initSentry } from './libs/errorLib';
import AppProvider from './AppProvider';
import { isDev } from './config';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './styles/root.scss';

initSentry();

ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

if (isDev) {
  serviceWorkerRegistration.unregister();
} else {
  serviceWorkerRegistration.register({
    // [2026-06-10] This function automatically refreshes the page when a new version is detected.
    // This ensures that users always see the latest version without having to click anywhere.
    // (Deployments take place overnight, so the silent update does not affect the user experience.)
    onUpdate: ({ waiting }) => {
      if (!waiting) return;
      // Reload once the new worker takes control of the page.
      waiting.addEventListener('statechange', event => {
        if ((event.target as ServiceWorker).state === 'activated') {
          window.location.reload();
        }
      });
      // Tell the waiting worker to skip the wait and activate immediately.
      waiting.postMessage({ type: 'SKIP_WAITING' });
    },
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
